// src/hooks/useWebShare.js
export function useWebShare() {
  const canShare = navigator.share !== undefined;

  const share = async ({ title, text, url }) => {
    if (!canShare) {
      alert("Web Share is not supported on your device.");
      return;
    }

    try {
      await navigator.share({ title, text, url });
      alert("✅ Thanks for sharing!");
    } catch (err) {
      console.warn("❌ Sharing failed:", err);
      alert(`Couldn't share: ${err.message}`);
    }
  };

  return { canShare, share };
}